import { render, staticRenderFns } from "./payLogin.vue?vue&type=template&id=38f2cde4&scoped=true"
import script from "./payLogin.vue?vue&type=script&lang=js"
export * from "./payLogin.vue?vue&type=script&lang=js"
import style0 from "./payLogin.vue?vue&type=style&index=0&id=38f2cde4&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f2cde4",
  null
  
)

export default component.exports